import React, { Component } from "react";

class NoData extends Component {
  render() {
    return (
      <p>
        You have not submitted any data. You may begin by completing the
        application form.
      </p>
    );
  }
}

export default NoData;
